import { ApiObjectHandler } from './abstract-handler';

import * as Types from '../../../types';

export class DatabaseHandler extends ApiObjectHandler<Types.DatabaseApi.Database> {}
